import * as React from 'react'
import { Stack } from 'react-bootstrap'
import FilterForm from '../FilterForm/FilterForm';
interface SupplierFilterProps{
    isOpen:boolean;
    title:string;
    filter:{active:boolean,inactive:boolean,all:boolean}
    onChange:(key:'active' | 'inactive' | 'all',value:boolean) => void

}
export const SupplierFilter = ({isOpen,title,filter,onChange}:SupplierFilterProps) => {
    return(
        
         <Stack gap={1} aria-expanded={isOpen} className='report-filter'>
            <div className='report-filter-title'>{title}</div>
            <FilterForm 
                      filters={[
                        {
                            type:'Checkbox',
                            label:'Inaktiva',
                            disabled:false,
                            value:filter.inactive,
                            key:'inactive',
                            onChange:onChange
                        },
                        {
                            type:'Checkbox',
                            label:'Aktiva',
                            disabled:false,
                            value:filter.active,
                            key:'active',
                            onChange:onChange
                            
                        },
                        {
                            type:'Checkbox',
                            label:'Alla',
                            disabled:false,
                            value:filter.all,
                            key:'all',
                            onChange:onChange
                        }
                      ]}
                    />
        </Stack>
        
    )
}